import {getCurrencySymbol} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ApiGetService} from '@ox/data';
import {SessionStorageService} from '@ox/utils';
import {find} from 'lodash';
import {map, of} from 'rxjs';

const offerKey = 'api/onStar/shop/offers/shop.en_US';

// TODO: Remove this service when the legacy Offers API dependency is removed
@Injectable()
export class OfferService {
  constructor(
    private http: HttpClient,
    private apiService: ApiGetService,
    private sessionStorage: SessionStorageService
  ) {
  }

  getOfferByProductId(productId: string, vin: any) {
    const findMatchingProductId = (response: any) => {
      const categories = response.offers;
      for (const category in categories) {
        const offerGroup = categories[category].offerGroup[0];
        const product = this.checkForMatch(offerGroup.offer, productId);
        if (product) {
          product.category = category;
          return product;
        }
      }
    };
    return this.getOffers(vin).pipe(
      map((offer) => findMatchingProductId(offer))
    );
  }

  getOffers(vin: string) {
    const storedOffers = this.sessionStorage.getFromJson(offerKey);
    if (storedOffers) {
      return of(storedOffers);
    } else {
      const url = '/api/onStar/shop/offers/shop';
      return this.apiService
        .get(url, {vin})
        .pipe(map((data) => this.formatData(data)));
    }
  }

  formatData(response: any) {
    const offers = response.data.offers;
    for (const i in offers) {
      const group = offers[i].offerGroup;
      for (const j in group) {
        const offer = group[j].offer;
        for (const k in offer) {
          offer[k].price.formatted =
            offer[k].shortDescription +
            ' - ' +
            getCurrencySymbol(offer[k].price.currencyCode, 'wide') +
            offer[k].price.amount;
        }
      }
    }
    this.sessionStorage.setAsJson(offerKey, response.data);
    return response.data;
  }

  checkForMatch(offers: any, productId: string) {
    return find(offers, (offer) => {
      return offer.id === productId;
    });
  }
}
